import {getFormData, PostResponse} from 'utils/HTTP'
import {ApplicationGroup} from "models/global/ApplicationGroup";
import {UserSettings} from "models/global/UserSettings";
import {AxiosResponse} from "axios";
import axios from "utils/axiosHelper";
import {ConnectionStatus} from "models/global/ConnectionStatus";
import {User} from "models/global/User";
import {PasswordChange} from "models/global/PasswordChange";

export const getInitialLoad = async (portfolioID: number | boolean = false): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxGetInitialLoad',
			portfolioID: portfolioID,
		}
	})
}
export const postAnnouncementTracker = async (id: number, status: number): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxPostAnnouncementTracker',
			id,
			status
		}
	})
}
export const getUserApplications = async (): Promise<AxiosResponse<PostResponse<ApplicationGroup[]>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxGetUserApplications',
		}
	})
}

export const getUserSettings = async (portfolioID: number | boolean = false): Promise<AxiosResponse<PostResponse<UserSettings>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxGetUserSettings',
			portfolioID: portfolioID,
		}
	})
}

export const getUserNotifications = async (): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxGetNotifications',
		}
	})
}

export const postToggleUserNotifications = async (ids: number[], state: number = 1): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxPostToggleUserNotifications',
			notificationTriggers: ids,
			state: state
		}
	})
}

export const getConnectionStatus = async (data): Promise<AxiosResponse<PostResponse<ConnectionStatus>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxGetConnectionStatus',
			linkHotel: data.hotel,
		}
	})
}

export const getSearch = async (searchString: string): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxSearch',
			searchString: searchString,
		}
	})
}

export const getSearchHistory = async (): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxSearchHistory',
		}
	})
}

export const getAppFavorites = async (): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxGetFavorites',
		}
	})
}

export const postAppFavorite = async (favoriteController: string): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxPostFavorite',
		favoriteController,
	}))
}

export const postAppFavoritesOrder = async (favorites: any): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxPostFavoritesOrder',
		favorites: JSON.stringify(favorites),
	}))
}

export const postProfile = async (user: User): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxPostProfile',
		firstName: user.firstName,
		lastName: user.lastName,
		language: user.language,
	}))
}

export const postPassword = async (password: PasswordChange): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxPostPassword',
		currentPassword: password.currentPassword,
		newPassword: password.newPassword,
		newPasswordConfirm: password.newPasswordConfirm,
	}))
}

export const postPreferences = async (options: any, registries): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxPostPreferences',
		options: JSON.stringify(options),
		registries: JSON.stringify(registries),
	}))
}

export const postProfilePicture = async (pictures: any): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxPostProfilePicture',
		original: pictures.original,
		cropped: pictures.cropped,
	}), {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}

export const removeProfilePicture = async (): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxRemoveProfilePicture',
	}))
}

export const generateToken = async (phone: string): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxGenerateToken',
		phone
	}))
}

export const verifyToken = async (phone: string, token: number): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxVerifyToken',
		phone,
		token
	}))
}

export const generateTOTP = async (): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxGenerateTOTP'
	}))
}

export const verifyTOTP = async (token: number): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxVerifyTOTP',
		token
	}))
}

export const removeAppFavorite = async (favoriteController: string): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxRemoveFavorite',
		favoriteController,
	}))
}

export const setRegistry = async (key: string, value: number | string | boolean): Promise<AxiosResponse<PostResponse<any>>> => {
	return await axios.post('index.php', getFormData({
		api: true,
		controller: 'HomeSettings',
		action: 'ajaxSetRegistry',
		key,
		value
	}))
}

export const getHotelPictureGroups = async (): Promise<AxiosResponse<PostResponse<any>>> => {

	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxGetHotelPictureGroups',
		}
	})
}

export const getSubstitutions = async (): Promise<AxiosResponse<PostResponse<any>>> => {

	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeSettings',
			action: 'ajaxGetSubstitutions',
		}
	})
}

export const enableSubstitutions = async (sender, receiver, portfolio): Promise<AxiosResponse<PostResponse<any>>> => {

	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeController',
			action: 'enableSubstitution',
			sender: sender,
			receiver: receiver,
			portfolio: portfolio
		}
	})
}

export const disableSubstitutions = async (sender, receiver, portfolio): Promise<AxiosResponse<PostResponse<any>>> => {

	return await axios.get('index.php', {
		params: {
			api: true,
			controller: 'HomeController',
			action: 'disableSubstitution',
			sender: sender,
			receiver: receiver,
			portfolio: portfolio
		}
	})
}

export const translateStrings = async (translations): Promise<AxiosResponse<PostResponse<any>>> => {

	return await axios.post('index.php?api=true&controller=HomeSettings&action=ajaxTranslateStrings', {
		translations: translations
	})
}
